export default __webpack_public_path__ + "static/media/error.a613fb58.png";